import type { PropsWithChildren } from "react";
import React, { useEffect, useRef } from "react";
import { Platform } from "react-native";
import { useQueryClient } from "@tanstack/react-query";

/** Dev-only telemetry (Reactotron). Render inside AppPersistQueryClientProvider. */
export const DevToolsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  if (!__DEV__ || Platform.OS === "web") return <>{children}</>;

  return (
    <>
      <ReactotronInit />
      {children}
    </>
  );
};

function ReactotronInit() {
  const queryClient = useQueryClient();
  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    const { initReactotron } = require("../config/reactotron");
    initReactotron(queryClient);
  }, [queryClient]);

  return null;
}
